import { useMutation } from '@tanstack/react-query';

import { UpdateUserPayload } from '../../../../../types';
import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { postCreateUser } from '../../requests/postCreateUser';

export const useCreateUser = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: createUser, ...rest } = useMutation({
    mutationFn: (data: UpdateUserPayload) =>
      postCreateUser(constructPost, data).then((response) => response?.data),
    onSuccess: () => handleSuccess('User invited.'),
    onError: (err) =>
      handleError(getApiErrorMessage(err, 'Failed to create user')),
  });

  return { createUser, ...rest };
};
